import PrintBatteryLabelButton from './PrintBatteryLabelButton';

export default PrintBatteryLabelButton;
